angular.module('app.directives').directive('customOnChange', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var onChangeHandler = scope.$eval(attrs.customOnChange);
            element.on('change', function (event) {
                scope.$apply(function () {
                    onChangeHandler(event);
                });
            });
            element.on('$destroy', function () {
                element.off();
            });
        }
    };
});
